import { useParams } from 'react-router-dom';
import { useState } from 'react';

import SMSTDetailChartsTitle from './SMSTDetailChartsTitle';

import { MCTChartType } from 'components/DevicesDetail/MCT/ChartType/MCTChartType';
import SimpleChartCard from 'components/DevicesDetail/MCT/TrapDetailCharts/SimpleLineChart/SimpleChartCart';
import { useAppSelector } from 'slices';
import TimeLineChartCard from 'components/DevicesDetail/MCT/TrapDetailCharts/TimeLineChart/TimeLineChartCart';
import HeatMapChartCart from 'components/DevicesDetail/MCT/TrapDetailCharts/HeatMapChart/HeatMapChartCart';
import PieEntersChart from 'components/DevicesDetail/MCT/TrapDetailCharts/PieEntersChart/PieEntersChart';
import PieActivationsChart from 'components/DevicesDetail/MCT/TrapDetailCharts/SnapPieActivationsChart/PieActivationsChart';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import HeatMapYearDropdown from 'pages/DevicesDetail/MCT/MCTDetailCharts/Components/HeatMapYearDropdown';
import HeatMapMonthDropdown from 'pages/DevicesDetail/MCT/MCTDetailCharts/Components/HeatMapMonthDropdown';

interface TabPanelProps {
  children?: React.ReactNode;
  chartName: string;
  currentChart: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, currentChart, chartName } = props;

  return (
    <div hidden={currentChart !== chartName} id={`Table-${chartName}`}>
      {currentChart === chartName && <>{children}</>}
    </div>
  );
}

const SMSTDetailCharts: React.FC = () => {
  const { slug } = useParams();
  const [currentYear, setCurrentYear] = useState<string>(new Date().getFullYear().toString());
  const [selectedMonth, setSelectedMonth] = useState<string | null>(null);
  const [chartHeaight, setChartHeight] = useState<number>(400);
  const [compareYear, setCompareYear] = useState<string>(new Date().getFullYear().toString());
  const [compareMonth, setCompareMonth] = useState<string | null>(null);
  const [isCompare, setIsCompare] = useState<boolean>(false);
  const [isBarChart, setIsBarChart] = useState(true);
  const currentChart = useAppSelector(state => state.DevicesDetailPages.currentMCTChartType);
  const shouldShowToggle = currentChart === MCTChartType.SimpleChart || currentChart === MCTChartType.TimeLineChart;

  return (
    <div className="card d-flex card-height-100 shadow-lg">
      <SMSTDetailChartsTitle
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        setSelectedMonth={setSelectedMonth}
        selectedMonth={selectedMonth}
        setChartHeight={setChartHeight}
        isBarChart={isBarChart}
        setIsBarChart={setIsBarChart}
        showSwitchChartType={shouldShowToggle}
        isHeatmapCompare={isCompare}
        setIsHeatmapCompare={setIsCompare}
        setCompareMonth={setCompareMonth}
        setCompareYear={setCompareYear}
      />
      <CustomTabPanel currentChart={currentChart} chartName={MCTChartType.SimpleChart}>
        <SimpleChartCard slug={slug || ''} type={TrapType.SMST} isBarChart={isBarChart} />
      </CustomTabPanel>
      <CustomTabPanel currentChart={currentChart} chartName={MCTChartType.TimeLineChart}>
        <TimeLineChartCard slug={slug || ''} type={TrapType.SMST} isBarChart={isBarChart} />
      </CustomTabPanel>
      <CustomTabPanel currentChart={currentChart} chartName={MCTChartType.HeatMapChart}>
        <div>
          <HeatMapChartCart
            slug={slug || ''}
            type={TrapType.SMST}
            currentYear={currentYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={e => {
              setSelectedMonth(e);
              if (isCompare && compareMonth == null) {
                setCompareMonth(e);
              }
            }}
            chartHeaight={chartHeaight}
            setChartHeight={setChartHeight}
          />
          {isCompare && (
            <div>
              <div className="d-flex flex-row gap-2 alight-items-center justify-content-start px-4">
                <HeatMapYearDropdown
                  currentYear={compareYear}
                  setCurrentYear={setCompareYear}
                  selectedMonth={compareMonth}
                  setSelectedMonth={setCompareMonth}
                />
                {selectedMonth && (
                  <HeatMapMonthDropdown
                    selectedMonth={compareMonth!}
                    setSelectedMonth={e => {
                      setCompareMonth(e);
                      if (isCompare && selectedMonth == null) {
                        setSelectedMonth(e);
                      }
                    }}
                  />
                )}
                {selectedMonth && (
                  <ul className="pagination p-0 m-0">
                    <button
                      className="page-link"
                      style={{ cursor: 'pointer', color: '#6A37D4', fontFamily: 'Poppins, sans-serif' }}
                      onClick={() => {
                        setSelectedMonth(null);
                        setCompareMonth(null);
                        setChartHeight(400);
                      }}
                    >
                      back to year
                    </button>
                  </ul>
                )}
              </div>
              <HeatMapChartCart
                slug={slug || ''}
                type={TrapType.MCT}
                currentYear={compareYear}
                selectedMonth={compareMonth}
                setSelectedMonth={e => {
                  setCompareMonth(e);
                  setSelectedMonth(e);
                }}
                chartHeaight={chartHeaight}
                setChartHeight={setChartHeight}
              />
            </div>
          )}
        </div>
      </CustomTabPanel>
      <CustomTabPanel currentChart={currentChart} chartName={MCTChartType.PieEntriesChart}>
        <PieEntersChart slug={slug || ''} type={TrapType.SMST} />
      </CustomTabPanel>
      <CustomTabPanel currentChart={currentChart} chartName={MCTChartType.PieActivationsChart}>
        <PieActivationsChart slug={slug || ''} type={TrapType.SMST} />
      </CustomTabPanel>
    </div>
  );
};

export default SMSTDetailCharts;
